//our root app component
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAlertDialog } from './alertdialog.type';
/**
 * dialog for pilotpay
 */
@Component({
	selector: 'app-pilotpay-alertdialog',
	styleUrls: ['./alertdialog.component.scss'],
	templateUrl: './alertdialog.component.html'
})
export class AlertDialogComponent {
	constructor(dialogRef: MatDialogRef<AlertDialogComponent>, @Inject(MAT_DIALOG_DATA) data: IAlertDialog) {
		this.dialogRef = dialogRef;
		this.modalType = data.modalType;
		this.name = data.name;
		this.modifiedDate = data.modifiedDate;
	}

	public modalType: string = 'discard';
	public name: string = '';
	public modifiedDate: Date;
	private dialogRef: MatDialogRef<AlertDialogComponent>;

	public discard(): void {
		this.dialogRef.close(true);
	}

	public downloadPreview(): void {
		this.dialogRef.close('preview');
	}

	public close(): void {
		this.dialogRef.close();
	}
}
